export function totalImpactLabel(impact:number) {
    if (impact >= 10) {
        return "Systemic";
    } else if (impact >= 5) {
        return "Acute";
    } else if (impact >= 1) {
        return "Major";
    } else if (impact >= 0.5) {
        return "Minor";
    } else {
        return "Modest";
    }
  }